import React, { useEffect, useState, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import API from '../../../utils/API';

const ImportFromCanva = ({
  setSuccess,
  closeModal,
}) => {

  const [formData, setFormData] = useState({
    folderName: ''
  });
  const [modalError, setModalError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });
  const [groupData, setGroupData] = useState([]);

  /**
    * Reset modal
    */
  function resetModal() {
    setSubmitted(false);
    setModalError('');
    setFormData({
      folderName: '',
    });
  }

//   useEffect(() => {
//     setGroupData(groupsTreeData);
//     if (groupsTreeData.length > 0) {
//       setFormData((prevData) => ({
//         ...prevData,
//         parentId: groupsTreeData[0].key,
//       }));
//     }
//   }, [groupsTreeData]);

  useEffect(() => {
    const modalElement = document.getElementById('importFromCanvaModal');
    modalElement.addEventListener('hidden.bs.modal', resetModal);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', resetModal);
    };
  }, []);

  /**
   * Handle form input change
   */
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (name === 'folderName' && (value.length < 2 || value.length > 36)) {
      setModalError(<FormattedMessage id="GROUP_NAME_LENGTH" />);
    } else {
      setModalError('');
    }
  }, []);

  /**
   * Add new group to the database
   */
  const handleAddNewFolder = async () => {
    const folderData = {
      folderName: formData.folderName.trim(),
    };
    if (folderData.folderName.length < 2 || folderData.folderName.length > 36) {
      setModalError(<FormattedMessage id="FOLDER_NAME_LENGTH" />);
      return;
    }
    try {
      await API.insertFolder(folderData);
      setSuccess(<FormattedMessage id="ADD_FOLDER_SUCCESS" />);
      closeModal("importFromCanvaModal");
      resetModal();
    } catch (err) {
      const errorMessage = err.response?.data?.errorId ? t(err.response.data["errorId"]) : err.message;
      setModalError(<FormattedMessage id="ADD_FOLDER_FAILED" values={{ errorMsg: <b>{errorMessage}</b> }} />);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (formData.folderName) {
      handleAddNewFolder();
    } else {
      setModalError(<FormattedMessage id="SUBMIT_ERROR" />);
    }
  };

  return (
    <div className='modal modal-mse fade' id='importFromCanvaModal' tabIndex='-1' aria-labelledby='importFromCanvaModalLabel' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content modal-mes-content'>
          <div className='modal-header modal-mes-header' style={{ backgroundColor: '#347BFA' }}>
            <h5 className='modal-title modal-mes-title'><FormattedMessage id='ADD_NEW_FOLDER' /></h5>
            <button id="closeModal" type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
          </div>
          <div className='modal-body'>
            <form onSubmit={handleSubmit}>
              <div className='row'>
                <div className='folderNameSection mb-2'>
                  <label htmlFor='folderNameLabel' className='font-weight-600 font-size-14 mb-2'>
                    <FormattedMessage id={'FOLDER_NAME'} />:
                  </label>
                  <input
                    id="folderNameInput"
                    onChange={handleChange}
                    value={formData.folderName}
                    name='folderName'
                    placeholder={t('FOLDER_NAME')}
                    className={`form-control h-54 bg-baby-blue ${submitted && (modalError ? 'is-invalid' : 'is-valid')}`}
                  />
                </div>
                {submitted && modalError && (
                  <div className='modal-error invalid-feedback d-block fw-bold text-center'>
                    {modalError}
                  </div>
                )}
              </div>
            </form>
          </div>
          <div className='modal-footer modal-mes-footer d-flex align-items-center'>
            <button id="backGroupModalBtn" type='button' className='btn btn-outline-secondary me-3' data-bs-dismiss='modal'>
              <FormattedMessage id='CANCEL' />
            </button>
            <button id="saveGroupBtn" className='btn btn-primary but-darkblue' type='button' onClick={handleSubmit}>
              <FormattedMessage id='CONTINUE' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportFromCanva;
